import { useUkQuizBlockedMessage } from '@capsicum/features/regulations/shared';
import styled from 'styled-components';

type UkQuizTryAgainModalProps = {
	attempts: null | number;
	blockedUntil: string;
};

export const UkQuizTryAgainModal = ({ attempts, blockedUntil }: UkQuizTryAgainModalProps) => {
	const { attemptsMessage, message } = useUkQuizBlockedMessage(blockedUntil, attempts);

	return (
		<S.DescriptionContainer>
			<S.Description>{message}</S.Description>
			{attemptsMessage && <S.Description>{attemptsMessage}</S.Description>}
		</S.DescriptionContainer>
	);
};
namespace S {
	export const DescriptionContainer = styled.div`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xxsmall};
		margin-top: ${({ theme }) => theme.spacings.xsmall};
	`;

	export const Description = styled.p`
		${({ theme }) => theme.fonts.text.text3};
		text-align: center;
		margin: 0;
		white-space: pre-line;
	`;
}
